import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';

var BASE_CSS = "".concat(cssClassPrefix, "-search-v2");
var IlSearchV2DropdownItem = /*#__PURE__*/function (_Component) {
  function IlSearchV2DropdownItem() {
    _classCallCheck(this, IlSearchV2DropdownItem);
    return _callSuper(this, IlSearchV2DropdownItem, arguments);
  }
  _inherits(IlSearchV2DropdownItem, _Component);
  return _createClass(IlSearchV2DropdownItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        _this$props$handleSel = _this$props.handleSelect,
        handleSelect = _this$props$handleSel === void 0 ? undefined : _this$props$handleSel;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        React__default.createElement("li", {
          className: "".concat(BASE_CSS, "__dropdown__item"),
          tabIndex: 0,
          role: "button",
          onClick: handleSelect,
          onKeyPress: this.handleKeyPress
        }, name)
      );
    }
  }]);
}(Component);
_defineProperty(IlSearchV2DropdownItem, "propTypes", {
  name: PropTypes.node.isRequired,
  handleSelect: PropTypes.func
});

export { IlSearchV2DropdownItem };
